import {apiGet} from 'app/shared-components/util/restAPI';


export default async function getFileURL(fileId)
{
    const apiName = 'PublicAPI';
	const path = '/uploadlink/public/' + encodeURIComponent(fileId) + '/url';
	let options = {
	  headers: {},
	  response: false, // OPTIONAL (return the entire Axios response object instead of only response.data)
	};

    //Request the upload link from the server
	return await apiGet(apiName, path, options);
}